import { Application } from "@hotwired/stimulus"
import { railsEnv } from "@uenf/layout"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}

import { layoutControllers } from "@uenf/layout"
for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}

import { definitions } from "stimulus:./controllers"
application.load(definitions);

import AddressController from "@uenf/layout/controllers/address"
application.register("address", AddressController);

import AutocompleteController from "@uenf/layout/controllers/autocomplete";
application.register("autocomplete", AutocompleteController);

import Clipboard from "@stimulus-components/clipboard";
application.register("clipboard", Clipboard);
